<template>
  <div class="content" v-if="show">
    <div class="c_result">
      <div class="left">
        关键字: "
        <span style="color:rgb(49, 104, 155);">{{mainKey}}</span>
        "， 共找到{{msglist.artical.total}}条结果， 共执行{{ msglist.time }}秒
      </div>
      <div>
        <template>
          <el-radio v-model="radio" label="1">只搜标题</el-radio>
          <el-radio v-model="radio" label="2">搜索全文</el-radio>
        </template>
      </div>
    </div>
    <div class="result_list">
      <div class="result_f" v-for="(item,index) in list" :key="index">
        <div v-if="item.type == 3">
          <div class="l_type">
            <div class="l_left">{{item.columnName}}</div>
            <div class="l_center" v-html="item.title"></div>
            <div class="l_download" @click="down(item.webAddress)">下载</div>
            <div class="l_right">{{item.createTime|dataFormat}}</div>
          </div>
        </div>
        <div v-else>
          <div class="l_type">
            <div class="l_left">{{item.columnName}}</div>
            <div @click="jump(item.id)" class="l_center" v-html="item.title"></div>
            <div class="l_right">{{item.createTime|dataFormat}}</div>
          </div>
          <div class="l_text" v-html="item.text"></div>
        </div>
      </div>
      <div class="block">
        <el-pagination
          background
          :current-page.sync="pageNum"
          @current-change="handleSizeChange"
          
          layout=" prev, pager, next, total, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import bus from "@/utils/bus";
export default {
  data() {
    return {
      radio: "1",
      currentPage4: 10,
      currentPage: 5,
      meglist: "",
      mainKey: "",
      total: 0,
      show: false,
      pageNum: 1,
      limit: 10,
      list: []
    };
  },
  methods: {
    testA() {
      this.btnSearch()
    },
    jump(data) {
      this.$router.push({
        path: "/ContentDetails",
        query: { pos1: "内容详情", pos2: "", data: data },
      });
    },
    down(path){
      window.open(`api/tourist/download/${path}?isRename=true`);
    },
    req() {
      var con = window.sessionStorage.getItem("search");
      this.mainKey = con;
      this.$axios({
        method: "GET",
        url: "tourist/searchArtical",
        params: {
          pageNum: this.pageNum,
          limit: this.limit,
          sign: this.radio,
          content: con,
        },
      })
        .then((res) => {
          this.list = null;
          this.list = res.data.data.artical.list;
          this.total = res.data.data.artical.total;
          this.msglist = res.data.data;
          // this.pageNum = res.data.data.artical.pageNum;
          // console.log(res);
        })
        .catch();
    },
    handleSizeChange(page) {
      this.pageNum = page;
      this.req();
    },
    pre() {
      if (!this.total) {
        return;
      }
      this.pageNum -= 1;
      this.req();
    },
    nex() {
      if (!this.total) {
        return;
      }
      this.pageNum += 1;
      this.req();
    },
    btnSearch() {
      this.req();
      this.mainKey = window.sessionStorage.getItem("search");
    },
  },
  filters: {
    dataFormat(msg) {
      var rs = msg.slice(0, 10);
      return rs;
    },
  },
  mounted() {
    bus.$on("testA", this.testA);
    // console.log(window.sessionStorage.getItem("search"));
    var con = window.sessionStorage.getItem("search");
    this.mainKey = con;
    this.$axios({
      method: "GET",
      url: "tourist/searchArtical",
      params: {
        pageNum: this.pageNum,
        limit: this.limit,
        sign: this.radio,
        content: con,
      },
    })
      .then((res) => {
        this.msglist = res.data.data;
        // this.total = res.data.total;
        // console.log(res.data.data);
        this.show = true;
        this.req();
      })
      .catch();

    // console.log(this.$route.query.data);
  },
};
</script>

<style lang='less' scoped>
.btn {
  text-align: center;
  position: fixed;
  left: 1488px;
  top: 55px;
  background-color: rgb(49, 104, 155);
  color: white;
  width: 78px;
  height: 40px;
  line-height: 40px;
  z-index: 100000;
  opacity: 0;
}
.btn:active {
  background-color: rgb(21, 71, 119);
  font-weight: 1000;
}
.btn:hover {
  cursor: pointer;
}
.el-radio {
  color: rgba(16, 16, 16, 1) !important;
  font-size: 14px !important;
}
.c_result {
  // margin-left: 353px;
  margin:0 20%;
  width: 1215px;
  height: 59px;
  background: #fbfbfb;
  line-height: 59px;
  font-size: 14px;
  border: 1px solid rgba(255, 255, 255, 0);
  padding-left: 20px;
  display: flex;
  flex-direction: row;
  .left {
    width: 80%;
  }
}
.result_list {
  max-height: 1384px;
  width: 1215px;
  // margin-left: 353px;
  margin:0 20%;
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  .result_f {
    width: 1197px;
    height: 163px;
    display: flex;
    flex-direction: column;
    .l_type {
      display: flex;
      // flex-direction: row;
      justify-content:space-between;
      .l_left {
        width: 80px;
        height: 30px;
        background: #1b7aca;
        text-align: center;
        line-height: 30px;
        color: white;
        font-size: 16px;
        border: 1px solid rgba(255, 255, 255, 0);
      }
      .l_download {
        color: #3584CA;
        margin-right:50px;line-height:30px;
        &:hover {
          cursor:pointer;
          color:#333;
          text-decoration: underline;
        }
      }
      .l_center {
        flex: 1;
        // width: 980px;
        height: 30px;
        color: rgba(49, 104, 155, 1);
        margin-left: 26px;
        line-height: 32px;
        font-size: 16px;
      }
      .l_center:hover {
        cursor: pointer;
        text-decoration: underline;
      }
      .l_right {
        color: #999ca1;;
        font-size: 16px;
        height: 30px;
        line-height: 32px;
        &:hover {
          color: #101010;
          cursor:auto;
          text-decoration:none;
        }
      }
    }
    .l_text {
      height: 45px;
      margin-top: 18px;
      width: 1197px;
      color: rgba(16, 16, 16, 1);
      font-size: 14px;
    }
  }
  .block {
    margin-left: 400px;
  }
}
</style>
<style>
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #30699b !important;
  color: #fff;
}
.el-radio__input.is-checked .el-radio__inner {
  border-color: #30699b !important;
  background: #30699b !important;
}
.el-radio__input.is-checked + .el-radio__label {
  color: #30699b !important;
}
</style>